/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
(function($) {
	

    if (window.matchMedia("(max-width: 767px)").matches) {
      // Viewport is less or equal to 700 pixels wide
    } else {
      // Viewport is greater than 700 pixels wide
    }

   $('.sample-switcher input').on('click', function() {        
      let relatedOption = $('[data-cboptname="' + $(this).data('option') + '"]');
      if ($(this).is(':checked')) {
        if (relatedOption.length > 0) {
          $(relatedOption).find('label')[0].click();
        }
      } else {
        if (relatedOption.length > 0) {
          $(relatedOption).find('label')[1].click();
        }
      }
    });
if ($('.cb-benefits > div').length > 3 ) {
   $('.cb-benefits').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    freeScroll: true,
    wrapAround: true,
    autoPlay: 2000,

  });
}



    $(document).ready(function() {
        setTimeout(function(){
          $('#wishlisthero-product-page-button-container').appendTo('.product__slides');
        },500)
      
	       console.log('ready!')
    });
})(jQuery);

(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
